import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0efaf7c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "search-box",
  style: {"display":"inline-block"}
}
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  class: "search-btn",
  style: {"position":"relative","overflow":"hidden"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont iconsearch" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "search-input",
      placeholder: _ctx.placeholder,
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event)),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchDelay(false)), ["enter"]))
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.searchString]
    ]),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("span", {
        class: "search-btn-mask",
        style: _normalizeStyle([{"position":"absolute","opacity":"0.1","background":"#0078d4","left":"0"}, { top: _ctx.top + 'px' }])
      }, null, 4),
      _hoisted_4
    ])
  ]))
}